import { CarService, AssignService, TpmsService, WheelService, TyreService } from '@/services';
import { networkStatus } from '@/constants/networkStatus';
import { getImageBySize } from '@/utils';
import { removeCookie } from '@/utils/js-cookie';

import {
  SET_RIMCONFIG_CAR_DATA,
  SET_CAR_WHEELS,
  SET_CAR_WHEELS_NEXT_PAGE,
  SET_CAR_WHEELS_CONCATENATED,
  SET_CAR_WHEELS_SELECTED_FILTERS,
  SET_CAR_WHEELS_ASSIGNS,
  SET_CAR_IMAGE,
  SET_SELECTED_WHEEL,
  SET_PREV_CAR_TAG,
  SET_CAR_COC_DATA,
  SET_CERTIFICATE_TEXTS,
  SET_SELECTED_CONFIGURATOR_WHEEL,
  SET_SELECTED_CONFIGURATOR_TPMS,
  SET_SELECTED_CONFIGURATOR_TYRE,
  RESET_SELECTED_CONFIGURATOR_WHEEL,
  RESET_SELECTED_CONFIGURATOR_TPMS,
  RESET_SELECTED_CONFIGURATOR_TYRE,
  SET_TPMS_DATA,
  // wheelset
  CLEAR_CONFIGURATOR_SET,
  LOAD_WHEEL_OVERVIEW,
  LOAD_WHEEL_SET,
  LOAD_CAR_DETAIL,
  LOAD_CAR_INFO,
  LOAD_TYRE_DETAIL,
} from '../mutationTypes';
import { isObjectEmpty } from '@/utils';

const state = {
  carData: {},
  carWheels: [],
  carImage: {},
  selectedWheel: {},
  prevCarTag: '',
  carCocData: [],
  carWheelAssignByWheelTag: {},
  carWheelsConcatenated: {},
  carWheelsSelectedFilters: {},
  certificateTexts: {},

  tpmsTable: [],

  selectedConfiguratorItems: {
    wheel: { },
    tpms: { },
    tyre: { },
  },
  tpmsData: [],

  //wheelset
  selectWheelAndCarInfo: {
    car: {},
    wheel: {},
    tpms: {},
  },
  selectWheelDetails: [],
  wheelOverviewCarTag: '',
  wheelSets: [],
  wheelSetsTpms: null,
  wheelDesignList: [],
  carDetail: {},
  carInfo: {},
  tyreDetail: {},
};

const mutations = {
  [SET_RIMCONFIG_CAR_DATA](stateData, data) {
    stateData.carData = {
      ...data,
    };
  },
  [SET_CAR_WHEELS](stateData, data) {
    stateData.carWheels = [...data];
  },
  [SET_CAR_WHEELS_NEXT_PAGE](stateData, data) {
    stateData.carWheels = [
      ...stateData.carWheels,
      ...data,
    ];
  },
  [SET_CAR_IMAGE](stateData, data) {
    stateData.carImage = {
      ...data[0],
    };
  },
  [SET_SELECTED_WHEEL](stateData, data) {
    stateData.selectedWheel = data;
  },
  [SET_PREV_CAR_TAG](stateData, data) {
    stateData.prevCarTag = data;
  },
  [SET_CAR_COC_DATA](stateData, data) {
    stateData.carCocData = [...data];
  },
  [SET_CAR_WHEELS_ASSIGNS](stateData, { wheelTag, data}) {
    stateData.carWheelAssignByWheelTag = {
      ...stateData.carWheelAssignByWheelTag,
      [wheelTag]: data,
    };
  },
  [SET_CAR_WHEELS_CONCATENATED](stateData, data) {
    stateData.carWheelsConcatenated = {
      ...data,
    };
  },
  [SET_CAR_WHEELS_SELECTED_FILTERS](stateData, data) {
    stateData.carWheelsSelectedFilters = {
      ...data,
    };
  },
  [SET_CERTIFICATE_TEXTS](stateData, data) {
    stateData.certificateTexts = {
      ...data,
    };
  },
  [SET_SELECTED_CONFIGURATOR_WHEEL](stateData, data) {
    const { assignIds, quantity, cartItems, isCombination } = data;
    stateData.selectedConfiguratorItems.wheel = {
      isCombination: isCombination,
      assignIds: [...assignIds],
      quantity: Number(quantity),
      cartItems: [...cartItems],
    };
  },
  [SET_SELECTED_CONFIGURATOR_TPMS](stateData, data) {
    const { assignId, quantity, cartItems } = data;
    stateData.selectedConfiguratorItems.tpms = {
      assignId: assignId,
      quantity: Number(quantity),
      cartItems: cartItems,
    };
  },
  [SET_SELECTED_CONFIGURATOR_TYRE](stateData, data) {
    const { assignId, quantity, cartItems } = data;
    stateData.selectedConfiguratorItems.tyre = {
      assignId: assignId,
      quantity: Number(quantity),
      cartItems: [...cartItems],
    };
  },
  [RESET_SELECTED_CONFIGURATOR_WHEEL](stateData) {
    stateData.selectedConfiguratorItems.wheel = {};
  },
  [RESET_SELECTED_CONFIGURATOR_TPMS](stateData) {
    stateData.selectedConfiguratorItems.tpms = {};
  },
  [RESET_SELECTED_CONFIGURATOR_TYRE](stateData) {
    stateData.selectedConfiguratorItems.tyre = {};
  },
  [SET_TPMS_DATA](stateData, data) {
    stateData.tpmsData = data;
  },
  // wheelset
  [CLEAR_CONFIGURATOR_SET](stateData) {
    stateData.selectWheelAndCarInfo = {
      car: {},
      wheel: {},
      tpms: {},
      tyres: {},
    };
  },
  [LOAD_WHEEL_OVERVIEW](stateData, { data, carTag }) {
    stateData.wheels = [
      ...data,
    ];
    stateData.wheelOverviewCarTag = carTag;
  },
  [LOAD_WHEEL_SET](stateData, { data, carTag, tpms }) {
    stateData.wheelSets = [
      ...data,
    ];
    stateData.wheelOverviewCarTag = carTag;
    stateData.wheelSetsTpms = tpms;
  },
  [LOAD_CAR_DETAIL](stateData, data) {
    stateData.carDetail = {
      ...data[0],
    };
  },
  [LOAD_CAR_INFO](stateData, data) {
    stateData.carInfo = {
      ...data,
    };
  },
  [LOAD_TYRE_DETAIL](stateData, data) {
    stateData.tyreDetail = {
      ...data,
    };
  },
};

const actions = {
  async loadCarByCarTag({ commit }, { carTag }) {
    const response = await CarService.getCarByCarTag({
      carTag,
    });

    if (response.status === networkStatus['ok']) {
      commit(SET_RIMCONFIG_CAR_DATA, response.data);
    }

    return response;
  },
  async getCarGroupByGermanCode({ commit }, payload) {
    const response = await CarService.getCarGroupByGermanCode(payload);
    return response;
  },
  async getCarWheels({ commit }, payload) {
    let adjustedPayload = {
      minStock: 1,
      ...payload,
    };
    const response = await CarService.getCarWheels(adjustedPayload);
    if (response.status === networkStatus.ok) {
      commit(SET_CAR_WHEELS, response.data);
    }
    return response;
  },
  async getCarWheelsNextPage({ commit }, payload) {
    let adjustedPayload = {
      minStock: 1,
      ...payload,
    };
    const response = await CarService.getCarWheels(adjustedPayload);
    if (response.status === networkStatus.ok) {
      commit(SET_CAR_WHEELS_NEXT_PAGE, response.data);
    }
    return response;
  },
  async getCarImage({ commit }, payload) {
    const response = await CarService.getCarImage(payload);

    commit(SET_CAR_IMAGE, response.data);

    return response;
  },
  async getCarWheelsConcatenated({ commit }, payload) {
    let adjustedPayload = {
      minStock: 1,
      ...payload,
    };
    const response = await CarService.getCarWheelsConcatenated(adjustedPayload);
    if (response.status === networkStatus['ok']) {
      commit(SET_CAR_WHEELS_CONCATENATED, response.data);
    }
    return response;
  },
  async getCertificateTexts({ commit }, payload) {
    const response = await CarService.getCertificateTexts(payload);
    if (response.status === networkStatus['ok']) {
      commit(SET_CERTIFICATE_TEXTS, response.data);
    }
    return response;
  },
  async getCarWheelAssigns({ commit }, { wheelTag, assigns }) {
    const response = await AssignService.getAssigns({ ids: assigns.join() });

    if (response.status === networkStatus['ok']) {
      commit(SET_CAR_WHEELS_ASSIGNS, {
        wheelTag: wheelTag,
        data: response.data,
      });
    }

    return response;
  },
  clearWheelOverview({ commit }) {
    commit(SET_CAR_WHEELS, []);
  },
  setSelectedWheel({ commit }, payload) {
    commit(SET_SELECTED_WHEEL, payload);
  },
  setPrevCarTag({ commit }, carTag) {
    commit(SET_PREV_CAR_TAG, carTag);
  },
  async getCarCoc({ commit }, catTags = []) {
    const response = await CarService.getCarCoc(catTags.join());

    if (response.status === networkStatus['ok']) {
      commit(SET_CAR_COC_DATA, response.data);
    }

    return response;
  },
  setSeletedFilters({ commit }, data) {
    commit(SET_CAR_WHEELS_SELECTED_FILTERS, data);
  },
  selectConfiguratorWheel({ commit }, data) {
    commit(SET_SELECTED_CONFIGURATOR_WHEEL, data);
    return data;
  },
  selectConfiguratorTpms({ commit }, data) {
    commit(SET_SELECTED_CONFIGURATOR_TPMS, data);
    return data;
  },
  selectConfiguratorTyre({ commit }, data) {
    commit(SET_SELECTED_CONFIGURATOR_TYRE, data);
    return data;
  },
  setSelectConfiguratorStep({ commit }, step = 1) {
    /**
     * step
     * 1 -> select wheel
     * 2 -> select tpms
     * 3 -> select tyre
     */
    commit(RESET_SELECTED_CONFIGURATOR_TYRE);
    if (step === 1) {
      commit(RESET_SELECTED_CONFIGURATOR_TPMS);
      commit(RESET_SELECTED_CONFIGURATOR_WHEEL);
    } else if (step === 2) {
      commit(RESET_SELECTED_CONFIGURATOR_TPMS);
    }
    return step;
  },
  async loadTpmsCar({ commit }, payload = {}) {
    const response = await TpmsService.getSensors(payload);

    if (response.status === networkStatus['ok']) {
      commit(SET_TPMS_DATA, response.data);
    }

    return response;
  },
  clearTpmsCar({ commit }) {
    commit(SET_TPMS_DATA, []);
  },
  // wheelset
  clearSelectData({ commit }) {
    removeCookie('selectWheelAndCarInfo');
    commit(CLEAR_CONFIGURATOR_SET);
  },
  async getFleetWheelSet({ commit }, data) {
    commit(LOAD_WHEEL_SET, {
      data: [],
      carTag: data.carTag,
      tpms: null,
    });
    const response = await WheelService.getWheelSet(data);
    if (response && response.status === networkStatus['ok']) {
      if (response.data.isSuccessful === false) {
        return Promise.reject(new Error('Sorry. Wheel is not found for this car.'));
      }

      commit(LOAD_WHEEL_SET, {
        data: response.data.wheelSets,
        carTag: data.carTag,
        tpms: response.data.tpms || null,
      });
    } else {
      return Promise.reject('error');
    }

    return response;
  },
  async getCarDetail({ commit }, data) {
    const response = await CarService.getCarByCarTag(data);

    if (response && response.status === networkStatus['ok']) {
      if (response.data[0].carImage.imageCarColour.length === 0) {
        return Promise.reject(new Error('langkey.color-not-found-for-the-car'));
      }
      commit(LOAD_CAR_DETAIL, response.data);
    } else {
      return Promise.reject('error');
    }
    return response;
  },
  async getCarInfo({ commit }, carTag) {
    const response = await CarService.getCarInfo(carTag);

    if (response && response.status === networkStatus['ok']) {
      commit(LOAD_CAR_INFO, response.data);
    } else {
      return Promise.reject('error');
    }

    return response;
  },
  async getTyreDetail({ commit }, { ean }) {
    const response = await TyreService.getTyreDetail(ean);

    if (response.status === networkStatus['ok']) {
      commit(LOAD_TYRE_DETAIL, response.data);
    }

    return response;
  },
};

const getters = {
  getGroupedCarWheelsByDiameter(stateData) {
    if (stateData.carWheels.length === 0) {
      return [];
    }
    const carWheelsWithAxisB = stateData.carWheels
      .filter((item) => {
        return item.wheels.some((wheel) => wheel.axisOnly === 'B');
      });

    // Get result with only axisOnly = 'B'
    const result = carWheelsWithAxisB.map((item) => {
      return {
        ...item,
        possibleDiameters: Object.fromEntries(
          item.wheels
            .filter((wheel) => wheel.axisOnly === 'B')
            .reduce((acc, cur) => {
              const key = cur.diameter;
              const wheelItem = acc.get(key) ?
                [
                  ...acc.get(key),
                  cur,
                ] :
                [cur];
              return acc.set(key, wheelItem);
            }, new Map()),
        ),
        wheels: item.wheels.filter((wheel) => wheel.axisOnly === 'B'),
      };
    }).map((group) => {
      let diameterPriceObject = {};
      Object.keys(group.possibleDiameters).forEach((key) => {
        diameterPriceObject = {
          ...diameterPriceObject,
          [key]: group.possibleDiameters[key].map((item) => item.prices.bestPrice)
            .reduce((acc, cur) => {
              return cur < acc ? cur : acc;
            }),
        };
      });

      const getMinimumDiameterPrice = Object.keys(group.possibleDiameters).map((key) => {
        return group.possibleDiameters[key].map((item) => item.prices.bestPrice)
          .reduce((acc, cur) => {
            return cur < acc ? cur : acc;
          });
      })[0];
      return {
        ...group,
        minimumDiameterPrice: getMinimumDiameterPrice,
        diameterPriceObject: diameterPriceObject,
      };
    });
    return result;
  },
  getCarWheelsSelectFilterOptions: (stateData) => (fields) => {
    if (isObjectEmpty(stateData.carWheelsConcatenated)) {
      return {};
    }

    let result = {};

    fields.forEach((field) => {
      if (stateData.carWheelsConcatenated[field.key]) {
        result[field.key] = Object.values(stateData.carWheelsConcatenated[field.key])
          .map((value) => {
            return {
              label: value,
              value: value,
            };
          });
      }
    });

    return result;
  },
  getTpmsData: (stateData) => {
    return stateData.tpmsData.forEach((element) => {
      return {
        articleId: element.articleId,
        brand: element.manufacturer,
        type: element.brand,
        image: getImageBySize(element.imageTemplate, 100, 30),
        article: `${element.description1} ${element.description2}`,
        bjVon: element.minCarBuildDate,
        bjBis: element.maxCarBuildDate,
        stock: 0,
        price: 0,
        totalPrice: 0,
      };
    });
  },
  getTyreSizeSelectFilterOptions: (stateData) => (params, query) => {
    if (stateData.carWheels.length === 0) {
      return [];
    }

    // Car wheels with only axisOnly = 'B'
    const carWheelsWithAxisBOnly = stateData.carWheels.slice()
      .filter((item) => {
        return item.wheels && item.wheels.some((wheel) => wheel.axisOnly === 'B');
      })
      .map((filteredItem) => {
        return {
          ...filteredItem,
          wheels: filteredItem.wheels && filteredItem.wheels.filter((wheel) => wheel.axisOnly === 'B'),
        };
      });

    const selectedWheels = carWheelsWithAxisBOnly.filter((wheel) => {
      return wheel.manufacturer.toLowerCase() === query.manufacturer.toLowerCase() &&
        wheel.design.toLowerCase() === query.design.toLowerCase() &&
        wheel.color.toLowerCase() === query.color.toLowerCase();
    });

    const isCombination = params.selectedWheel.includes('+') ? true : false;
    let wheelArticleId;
    let result = [];

    if (!isCombination) {
      wheelArticleId = params.selectedWheel;
      const selectedWheel = selectedWheels[0].wheels.find((wheel) => {
        return wheel.man === wheelArticleId;
      });

      const selectedWheelFrontTyres = selectedWheel.tyres && selectedWheel.tyres.front;
      if (selectedWheelFrontTyres) {
        result = selectedWheelFrontTyres.map((tyre) => {
          return {
            label: `${tyre.width}/${tyre.aspectratio} ${tyre.size}`,
            value: `${tyre.width}/${tyre.aspectratio} ${tyre.size}`,
          };
        });
      }
    } else {
      wheelArticleId = {
        front: params.selectedWheel.split('+')[0],
        rear: params.selectedWheel.split('+')[1],
      };
      const selectedWheelCombinationFront = selectedWheels[0].wheels.find((wheel) => {
        return wheel.man === wheelArticleId.front;
      });
      const selectedWheelCombinationRear = selectedWheels[0].wheels.find((wheel) => {
        return wheel.man === wheelArticleId.rear;
      });

      const selectedWheelCombinationFrontTyres = selectedWheelCombinationFront.tyres && selectedWheelCombinationFront.tyres.front;
      if (selectedWheelCombinationFrontTyres) {
        selectedWheelCombinationFrontTyres.forEach((frontTyre) => {
          frontTyre.rear.forEach((rearTyre) => {
            result.push({
              ...frontTyre,
              rearTyre: rearTyre,
            });
          });
        });
        result = result.map((combination) => {
          let dimension = `${combination.width}/${combination.aspectratio} ${combination.size} - ${combination.rearTyre.width}/${combination.rearTyre.aspectratio} ${combination.rearTyre.size}`;
          return {
            label: dimension,
            value: dimension,
          };
        });
      }
    }
    return result;
  },
  // wheelset
  getPossibleOffsetOfSelectWheel: (stateData) => (diameter, colour) => {
    const result = stateData.selectWheelDetails.slice().filter((item) => item.diameter === diameter && item.colour === colour)
      .map((filterItem) => filterItem.offset);
    return [...new Set(result)].sort((a, b) => a - b);
  },
  hasWheelOverviewOfCarTag: (stateData) => (carTag) => {
    return stateData.wheelOverviewCarTag === carTag;
  },
  getGroupedWheelSet: (stateData) => {
    const result = stateData.wheelSets.slice().map((item) => {
      let diameters = item.carWheelSet.slice().map((set) => {
        return set.diameter;
      });
      diameters = diameters.slice().filter((diameter, index) => {
        return index === diameters.findIndex((dia) => dia === diameter);
      });
      let offsets = item.carWheelSet.slice().map((set) => {
        return { diameter: set.diameter, offset: set.offset };
      });
      offsets = offsets.slice().filter((offset, index) => {
        return index === offsets.findIndex((offs) => {
          return offs.diameter === offset.diameter;
        });
      });
      item.carWheelSet.forEach((carSet) => {
        const offers = [];
        Object.keys(carSet.seasons).forEach((season) => {
          carSet.seasons[season].forEach((offer) => {
            offers.push({ ...offer });
          });
        });
        carSet.offers = offers;
      });
      const sizes = item.carWheelSet.slice().map((set, index) => {
        const offers = set.offers.slice().map((offer) => offer.offerPrice);
        return {
          width: set.width,
          diameter: set.diameter,
          offset: set.offset,
          price: offers.length === 0 ? 0 : Math.min(...offers),
          setIndex: index,
          offerLength: offers.length,
        };
      });
      const winters = item.carWheelSet.slice().map((set) => set.winter);
      const forWinterUse = winters.some((winter) => winter);
      return {
        ...item,
        diameters,
        offsets,
        sizes,
        forWinterUse,
      };
    }).filter((item) => {
      const isNoOffer = item.sizes.every((item) => item.offerLength === 0);
      return item.sizes.length > 0 && !isNoOffer;
    }).sort((a, b) => {
      return a.color.localeCompare(b.color);
    }).sort((a, b) => {
      return a.design.localeCompare(b.design);
    }).sort((a, b) => {
      return a.manufacturer.localeCompare(b.manufacturer);
    });
    return result;
  },
  getWheelSetsFilterItems: (stateData) => (filterData) => {
    const filteredItems = stateData.wheelSets
      .slice()
      .filter((item) => {
        let tmp = [];
        Object.keys(filterData).forEach((filterKey) => {
          if (['diameter', 'winter'].includes(filterKey)) {
            if (filterData[filterKey].length === 0) {
              tmp.push(true);
            } else {
              const findIndex = item.carWheelSet.findIndex((wheelSet) => {
                return filterData[filterKey].includes(wheelSet[filterKey]);
              });
              tmp.push(findIndex > -1);
            }
          } else if (filterData[filterKey].length === 0 ||
                      filterData[filterKey][0] === false ||
                      filterData[filterKey][0] === '0' ||
                      filterData[filterKey][0] === 0) {
            tmp.push(true);
          } else {
            tmp.push(filterData[filterKey].includes(item[filterKey]));
          }
        });
        return tmp.every((val) => val);
      })
      .map((item) => {
        let diameters = item.carWheelSet.slice().map((set) => {
          return set.diameter;
        });
        diameters = diameters.slice().filter((diameter, index) => {
          return index === diameters.findIndex((dia) => dia === diameter);
        });
        let offsets = item.carWheelSet.slice().map((set) => {
          return { diameter: set.diameter, offset: set.offset };
        });
        offsets = offsets.slice().filter((offset, index) => {
          return index === offsets.findIndex((offs) => {
            return offs.diameter === offset.diameter;
          });
        });
        item.carWheelSet.forEach((carSet) => {
          const offers = [];
          Object.keys(carSet.seasons).forEach((season) => {
            carSet.seasons[season].forEach((offer) => {
              offers.push({ ...offer });
            });
          });
          carSet.offers = offers;
        });
        const sizes = item.carWheelSet.slice().map((set, index) => {
          const offers = set.offers.slice().map((offer) => offer.offerPrice);
          return {
            width: set.width,
            diameter: set.diameter,
            offset: set.offset,
            price: offers.length === 0 ? 0 : Math.min(...offers),
            setIndex: index,
            offerLength: offers.length,
          };
        });
        const winters = item.carWheelSet.slice().map((set) => set.winter);
        const forWinterUse = winters.some((winter) => winter);
        return {
          ...item,
          diameters,
          offsets,
          sizes,
          forWinterUse,
        };
      }).filter((item) => {
        const isNoOffer = item.sizes.every((item) => item.offerLength === 0);
        return item.sizes.length > 0 && !isNoOffer;
      }).sort((a, b) => {
        return a.color.localeCompare(b.color);
      }).sort((a, b) => {
        return a.design.localeCompare(b.design);
      }).sort((a, b) => {
        return a.manufacturer.localeCompare(b.manufacturer);
      });
    return filteredItems;
  },
  getWheelSetFilterOption: (stateData, getters) => (fields) => {
    let filterItem = {};
    fields.forEach((obj) => {
      let diameters = [];
      getters.getGroupedWheelSet.forEach((item) => {
        item.diameters.forEach((diameter) => {
          diameters.push(diameter);
        });
      });
      const filteredGroupedWheelOverview = getters.getGroupedWheelSet.slice().filter((item) => item[obj.key]);
      const filteredDiameters = diameters.slice().filter((value) => value);
      filterItem = {
        ...filterItem,
        [obj.key]: [...new Set(filteredGroupedWheelOverview.map((item) => item[obj.key]))].sort((a, b) => a - b || a.localeCompare(b)),
        diameter: [...new Set(filteredDiameters)].sort((a, b) => a - b || a.localeCompare(b)),
      };
    });
    return filterItem;
  },
  getWheelSetFilterDynamicOption: (stateData, getters) => (fields, filterData, filterItems) => {
    let result = {};
    let eachFilterPossibleOption = {};
    let nonFilterOption = {};
    const filterDataKeys = Object.keys(filterData).filter((selectFilter) => filterData[selectFilter] && filterData[selectFilter].length !== 0).map((key) => key);
    const nonFilterDataKeys = fields.filter((field) => !filterDataKeys.includes(field.key)).map((nonIncludeField) => nonIncludeField.key);

    filterDataKeys.forEach((selectFilter) => {
      const customFilterData = {
        ...filterData,
        [selectFilter]: [],
      };
      const customFilterItems = getters.getWheelSetsFilterItems(customFilterData);
      let customFilterItemDiameters = [];
      if (selectFilter === 'diameter') {
        customFilterItems.forEach((item) => {
          item.diameters.forEach((diameter) => {
            customFilterItemDiameters.push(diameter);
          });
        });
        eachFilterPossibleOption = {
          ...eachFilterPossibleOption,
          diameter: customFilterItemDiameters,
        };
      } else {
        eachFilterPossibleOption = {
          ...eachFilterPossibleOption,
          [selectFilter]: customFilterItems,
        };
      }
    });

    nonFilterDataKeys.forEach((nonFilter) => {
      let diameters = [];
      if (nonFilter === 'diameter') {
        filterItems.forEach((item) => {
          let itemDiameters = item.carWheelSet.slice().map((carSets) => {
            return carSets.diameter;
          });
          itemDiameters = itemDiameters.slice().filter((diameter, index) => {
            return index === itemDiameters.findIndex((dia) => dia === diameter);
          });
          itemDiameters.forEach((diameter) => {
            diameters.push(diameter);
          });
        });
        nonFilterOption = {
          ...nonFilterOption,
          diameter: diameters,
        };
      } else {
        nonFilterOption = {
          ...nonFilterOption,
          [nonFilter]: filterItems,
        };
      }
    });

    fields.forEach((field) => {
      if (eachFilterPossibleOption[field.key]) {
        const filtered = eachFilterPossibleOption[field.key].slice().filter((item) => item[field.key]);
        let filteredDiameters = null;
        if(typeof eachFilterPossibleOption['diameter'] != 'undefined') {
          filteredDiameters = eachFilterPossibleOption['diameter'].slice().filter((value) => value);
        }
        if (field.key === 'diameter' && filteredDiameters) {
          result = {
            ...result,
            diameter: [...new Set(filteredDiameters)].sort((a, b) => a - b || a.localeCompare(b)),
          };
        } else {
          result = {
            ...result,
            [field.key]: [...new Set(filtered.map((item) => item[field.key]))].sort((a, b) => a - b || a.localeCompare(b)),
          };
        }
      } else {
        const filtered = nonFilterOption[field.key].slice().filter((item) => item[field.key]);
        let nonFilteredDiameters = null;
        if(typeof nonFilterOption['diameter'] != 'undefined') {
          nonFilteredDiameters = nonFilterOption['diameter'].slice().filter((value) => value);
        }
        if (field.key === 'diameter' && nonFilteredDiameters) {
          result = {
            ...result,
            diameter: [...new Set(nonFilteredDiameters)].sort((a, b) => a - b || a.localeCompare(b)),
          };
        } else {
          result = {
            ...result,
            [field.key]: [...new Set(filtered.map((item) => item[field.key]))].sort((a, b) => a - b || a.localeCompare(b)),
          };
        }
      }
    });
    return result;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
